<p-dialog 
    [(visible)]="visible"
    [modal]="true"
    [closable]="true"
    [closeOnEscape]="true"
    [dismissableMask]="false"
    [draggable]="false"
    [resizable]="false"
    [header]="''"
    [styleClass]="'confirmation-dialog'"
    [style]="{ width: width, maxWidth: '90vw' }"
    (onHide)="onHide()">

    <div class="dialog-content">
        <div class="icon-wrapper" *ngIf="showIcon">
            <i [class]="dialogIcon" [style.color]="dialogIconColor"></i>
        </div>
        <h2 class="dialog-title" *ngIf="title">{{ title }}</h2>
        <p class="dialog-message" *ngIf="message && !hasProjectedContent">{{ message }}</p>
        
        <!-- Projected content area for tables, forms, or other complex content -->
        <div class="dialog-projected-content" *ngIf="hasProjectedContent">
            <ng-content select="[body]"></ng-content>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <div class="dialog-footer">
            <ng-content></ng-content>
        </div>
    </ng-template>
</p-dialog>
